import { FT, Spine } from 'ft'

const $SPINE_DRAG = 'spine.SC03-5'
const $soundHeroDrag = 'sound.hero-drag'
FT.rm.addSpine($SPINE_DRAG)
FT.rm.addSound($soundHeroDrag)

const map = {
  yi: 'YI',
  md: 'MD',
  neeko: 'NEEKO',
  akl: 'AKL',
  ls: 'LS2',
  slk: 'SLK',
}

class DragHero extends Spine {
  constructor(heroId) {
    super(FT.rm.spine($SPINE_DRAG))
    this.scale.set(0.5, 0.5)
    this.position.set(FT.stage.centerX, FT.stage.centerY)
    const skinName = map[heroId]
    this.skeleton.setSkinByName(skinName)
  }

  play() {
    return new Promise(resolve => {
      const onComplete = () => {
        sound.stop()
        resolve()
      }
      this.state.addListener({ complete: onComplete })
      this.state.setAnimation(0, 'Drag')
      const sound = FT.rm.sound($soundHeroDrag).play()
      sound.loop = true
    })
  }
}

export default DragHero
